/**
 * Client-side helper function for forms. Given a previous value and a new value, it normalizes falsey values and returns a non-empty string for a changed value or null for a removed value. If there was no change, it returns undefined.
 * @param input The new value from form data
 * @param existing The existing value from gql
 * @returns A non-empty string, null, or undefined
 */
export const getNormalizedFormInput = <T extends string>(
  input: string | undefined | null,
  existing: T | undefined | null,
) => {
  const normalizeFormValue = (value: string | undefined | null) => (value as T) || null;
  return normalizeFormValue(input) !== normalizeFormValue(existing) ? normalizeFormValue(input) : undefined;
};
